/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption;
(function (FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption) {
    FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption["Unspecified"] = 0] = "Unspecified";
    FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption["Disabled"] = 1] = "Disabled";
    FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption["Brotli"] = 2] = "Brotli";
    FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption["Gzip"] = 3] = "Gzip";
    FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption || (FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption = {}));
export function instanceOfFxIdDomainSettingsUnityOptionsDistributionForceCompressionOption(value) {
    for (const key in FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption, key)) {
            if (FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionToJSON(value) {
    return value;
}
export function FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption.js.map